export default __webpack_public_path__ + "static/media/houseprice.640f874d.jpg";